import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import { ActivatedRoute, Router } from "@angular/router";

import { ExcelService } from '../services/excel.service';
import { ProdutoService } from '../services/produto.service';
import { FornecedorService } from '../services/fornecedor.service';
import { ProdutoSaidaService } from '../services/produto-saida.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-produto-saida',
  templateUrl: './produto-saida.component.html',
  styleUrls: ['./produto-saida.component.css'],
  animations: [loadingFade, modal, alert]
})
export class ProdutoSaidaComponent implements OnInit {
  public loading = false;
  public saidas;

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;

  // filtro
  public filtro = [];
  public dadosFiltrados = [];
  public formFiltro: FormGroup;
  public showFilter = true;

  public produtos;
  public fornecedores;

  constructor(private fb: FormBuilder,
              private produtoSaidaSvc: ProdutoSaidaService,
              private produtoSvc: ProdutoService,
              private fornecedorSvc: FornecedorService,
              private router: Router,	
              private route: ActivatedRoute,	              
              private excelSvc: ExcelService) { }

  ngOnInit() {
    this.pegaSaidas();
    this.pegaProdutos();
    this.pegaFornecedores();
    this.criaFiltro();
  }

  pegaProdutos(){
    this.produtoSvc.getProdutos().then((data: any) =>{
      this.produtos = data;
    }).catch((err) =>{
      console.log(err);
    });
  }

  pegaFornecedores(){
    this.fornecedorSvc.getFornecedores().then((data: any) =>{
      this.fornecedores = data;
    }).catch((err) =>{
      console.log(err);
    });
  }

  pegaSaidas(){
    this.loading = true;
    this.produtoSaidaSvc.getProdutoSaidas().then((data: any) =>{
      this.saidas = data;
      this.count = this.saidas.length;
      this.loading = false;
    }).catch((err) => {
      console.log(err);
      this.loading = false;
    });
  }

  primPagina() {
    this.page = 1;
  }

  paginaAnt() {
    this.page = Math.max(this.page - 1, 1);
  }

  proxPagina() {
    this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
  }

  ultPagina() {
    this.page = Math.ceil(this.count / this.limit);
  }

  apagaSaida(id) {
    Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.produtoSaidaSvc.apagaProdutoSaida(id).then((data) => {
					this.pegaSaidas();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		});
  }

  exportarExcel() {
    let data = [];
    if (this.dadosFiltrados.length == 0) {
      this.dadosFiltrados = this.saidas;
    }
    for (let index in this.dadosFiltrados) {
      data[index] = {
        'Data':             moment(this.dadosFiltrados[index].produto_saida_data).format('DD/MM/YYYY'),
        'Pedido':           this.dadosFiltrados[index].produto_saida_pedido,
        'Preço de Compra':  this.dadosFiltrados[index].produto_saida_valor_total,
        'Quantidade':       this.dadosFiltrados[index].produto_saida_quantidade,
        'Cod. Produto':     this.dadosFiltrados[index].produto.produto_codigo,
        'Descrição':        this.dadosFiltrados[index].produto.produto_descricao,
        'Fornecedor':       this.dadosFiltrados[index].produto.fornecedor.fornecedor_nome,
        'Localização':      this.dadosFiltrados[index].produto.produto_localizacao,
      };
    }

    this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Saida de produtos');
  }

  criaFiltro() {
    this.formFiltro = this.fb.group({
      produto_saida_pedido___pedido: '',
      produto_id___produto: null,
      fornecedor_id___fornecedor: null,
      produto_saida_data___data_i: null,
      produto_saida_data___data_f: null
    });

    let campos_data = ['produto_saida_data___data_i', 'produto_saida_data___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}


    this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");
	  
			  let loProdutoSaida = null;
			  let loProdutoID = null;
			  let loFornecedor = null;
			  let loData_i = "";
			  let loData_f = "";
	  
			  this.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "produto_saida_pedido___pedido": { 
	  
					if(loSplitValor[1] !== "null"){
					  loProdutoSaida = loSplitValor[1];
					}
					 break; 
	  
				  } 
				  case "produto_id___produto": { 
					if(loSplitValor[1] !== "null"){
					  loProdutoID = parseInt(loSplitValor[1]);
					}
	  
					break; 
				  }
				  case "fornecedor_id___fornecedor": { 
            if(loSplitValor[1] !== "null"){
              loFornecedor = parseInt(loSplitValor[1]);
            }
      
            break; 
            }          
				  case "produto_saida_data___data_i": { 
					if(loSplitValor[1] !== "null"){
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				  case "produto_saida_data___data_f": { 
					if(loSplitValor[1] !== "null"){
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				 }
	  
			  }
			  this.preencheForm({
          produto_saida_pedido___pedido: loProdutoSaida,
          produto_id___produto: loProdutoID,
          fornecedor_id___fornecedor: loFornecedor,
				  produto_saida_data___data_i: loData_i,
				  produto_saida_data___data_f: loData_f
			  });
			  this.filtra();
	  
			}
	  
		  });	    


      


  }


  preencheForm(dados) {
		this.formFiltro.setValue(dados);
	}

  filtra() {
    this.filtro = this.formFiltro.value;
    this.dadosFiltrados = new FiltroPipe().transform(this.saidas, this.filtro);
    this.count = this.dadosFiltrados.length;
    this.page = 1;
  }

  expandPanel() {
    this.showFilter = this.showFilter == true ? false : true;
  }


	EditSaida(produto_saida_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		//Envia dados
		this.router.navigate(['home/produto-saida/edit/' + produto_saida_id + params] );
	}

  VerSaida(produto_saida_id){
    this.router.navigate(['home/produto-saida/ver/' + produto_saida_id] );
  }

    onClickLimparCampos(){
      this.formFiltro = this.fb.group({
        produto_saida_pedido___pedido: '',
        produto_id___produto: null,
        fornecedor_id___fornecedor: null,
        produto_saida_data___data_i: null,
        produto_saida_data___data_f: null
      });
    }

}
